import type { FirmMembershipWithProfile } from '@thinkalpha/ui-types/types/admin/firms';
import type { User } from '@thinkalpha/ui-types/types/admin/users';
import type { UserDetails } from '@thinkalpha/ui-types/types/user';

export function formatUser(user: User | UserDetails | FirmMembershipWithProfile) {
    const firstName = 'profile' in user ? user.profile.firstName : user.firstName;
    const lastName = 'profile' in user ? user.profile.lastName : user.lastName;
    const email = 'profile' in user ? user.profile.email : user.email;

    return `${firstName} ${lastName} (${email})`;
}
